export default __webpack_public_path__ + "media/images/react_icons/stopwatch-08473d76222bbfba213f307471b55240.svg";